import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type WhatsappLiveChatModuleSpecsFragment } from '../../../../api/fragments/WhatsappLiveChatModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import WhatsappLiveChatModuleUpdateForm from './WhatsappLiveChatModuleUpdateForm';

export type WhatsappLiveChatUpdateModuleDrawerProps = {
    module: WhatsappLiveChatModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const WhatsappLiveChatUpdateModuleDrawer = ({ module, onClose, visible }: WhatsappLiveChatUpdateModuleDrawerProps) => {
    const { t } = useTranslation(['whatsappLiveChatModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('whatsappLiveChatModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateWhatsappLiveChatModule" htmlType="submit" type="primary">
                        {t('whatsappLiveChatModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('whatsappLiveChatModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <WhatsappLiveChatModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default WhatsappLiveChatUpdateModuleDrawer;

export const useUpdateWhatsappLiveChatModuleDrawer = (module: WhatsappLiveChatUpdateModuleDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <WhatsappLiveChatUpdateModuleDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
